// @flow

// Decoders
import decoder from './decoder'
import { toJson } from 'fc-decoders'

// Model Properties
import {
  PROP_SHAPE,
} from 'fc-model-assets'

// Exports
export default {
  ...decoder,
  [PROP_SHAPE]: toJson,
}
